export default "__VITE_ASSET__BFYk3BVN__"